export default __webpack_public_path__ + "static/media/field.d04935b9.jpeg";